<div>
    <header class="page-header">
        <div class="row">
            <div class="col-md-4">
                <h2 class="title pull-left">Notifications</h2>
            </div>
        </div>
    </header>

    <sp-user-notifications-display 
        [userNotifications]="userNotifications$ | async">
    </sp-user-notifications-display>
</div>